
        <img [ngClass]="{hide: entryIdx != 0, fade: fadeIdx == 0}" [src]="entrySources[0]">
        <img [ngClass]="{hide: entryIdx != 1, fade: fadeIdx == 1}" [src]="entrySources[1]">
        <img [ngClass]="{hide: entryIdx != 2, fade: fadeIdx == 2}" [src]="entrySources[2]">
    